import React from 'react'
import { SVGIconProps } from '../types'
const SvgTimerOff = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fill="none"
      d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
    />
    <path d="m19.04 4.55-1.42 1.42a9.01 9.01 0 0 0-10.57-.49l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45A8.9 8.9 0 0 0 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42zM15 1H9v2h6zm-4 8.44 2 2V8h-2zM3.02 4 1.75 5.27 4.5 8.03A8.9 8.9 0 0 0 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96" />
  </svg>
)
export default SvgTimerOff
